/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {takeUntil, tap} from 'rxjs/operators';

import * as moment from 'moment';

import {DATE_MAX} from '../../../../app.constants';
import {Contract} from '../../../employees/employees.model';
import {DateLocalizationPipe} from '../../../pipes/date-localization.pipe';
import {AbstractField} from '../abstract-field';

/**
 * Field for select a contract
 */
@Component({
  selector: 'gp-form-field-contract',
  templateUrl: 'contract-field.component.html',
  styleUrls: ['contract-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContractFieldComponent extends AbstractField implements OnInit {

  public contracts: Contract[] = [];
  public items: any[] = [];

  constructor(private dateLocalizationPipe: DateLocalizationPipe,
              private translate: TranslateService) {
    super();
  }

  ngOnInit(): void {
    const selectedContract = this.contracts.find(contract => contract.id === this.value.value);
    this.items = this.contracts.map(contract => {
      return {value: contract.id, display: this.setContractDisplay(contract)};
    });
    if (!selectedContract) {
      this.items.push({value: this.value.value, display: `${this.value.value}`});
    }
    this.control.valueChanges.pipe(
      tap(value => this.value.value = value),
      takeUntil(this.componentDestroyed$)
    ).subscribe();
  }

  public setContractDisplay(contract: Contract) {
    const text: string = this.translate.instant('EMPLOYEE_FORM.Contract_name', {
      name: contract.cliRegNickName
    });
    if (this.isInactiveContract(contract.enddate)) {
      return contract.flag
        ? `<img class="flag-icon" src="${contract.flag.href}" />
            <span class="inactive">${text} ${this.getContractDate(contract)}</span>`
        : `<span class="inactive">${text} ${this.getContractDate(contract)}</span>`;
    } else {
      return contract.flag
        ? `<img class="flag-icon" src="${contract.flag.href}" />
            ${text} ${this.getContractDate(contract)}`
        : `${text} ${this.getContractDate(contract)}`;
    }
  }

  public isInactiveContract(enddate: Date): boolean {
    return moment(enddate).isBefore(moment());
  }

  public getContractDate(contract: Contract): string {
    return `(${
      this.dateLocalizationPipe.transform(contract.begindate)
    } - ${
      contract.enddate === DATE_MAX || !contract.enddate
        ? '...'
        : this.dateLocalizationPipe.transform(contract.enddate)
    })`;
  }
}
